import axios from "axios"
import { API_BASE_URL } from "../config"

export const manageDeviceCreate = async (serial_no: string, estate_id: string) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/device/create`, {
        session_code: localStorage.getItem("session_code"),
        serial_no: serial_no,
        estate_id: estate_id
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
